<template>
  <div class="vg-content">
    <div class="item">
      <div class="item-entry" style="margin-top: 0px;">
        <div class="item-title">验真时间：</div>
        <div class="item-text">{{ details.verifyTime }}</div>
      </div>
      <div class="item-entry">
        <div class="item-title">项目：</div>
        <div class="item-text">{{ details.projectName }}</div>
      </div>
      <div class="item-entry">
        <div class="item-title">品牌名称：</div>
        <div class="item-text" style="font-weight: bold;">{{ details.brandName }}</div>
      </div>
      <div class="item-entry">
        <div class="item-title">商铺号：</div>
        <div class="item-text">{{ details.storeCode }}</div>
      </div>
      <div class="item-entry">
        <div class="item-title">申请人：</div>
        <div class="item-text">{{ details.realName }}</div>
      </div>
      <div class="item-entry">
        <div class="item-title">手机号：</div>
        <div class="item-text">{{ details.mobileNo }}</div>
      </div>
    </div>

    <div class="item" style="margin-top: 10px;">
      <div class="item-entry" style="margin-top: 0px;">
        <div class="item-title">申请事项：</div>
        <div class="item-text" style="font-weight: bold;">{{ getActionType(details.actionTypeDesc) }}</div>
      </div>
      <div class="item-entry">
        <div class="item-title">审核人：</div>
        <div class="item-text">{{ details.approveUserName }}</div>
      </div>
      <div class="item-entry">
        <div class="item-title">货品种类：</div>
        <div class="item-text" style="font-weight: bold;">{{ details.category }}</div>
      </div>
      <div class="item-entry">
        <div class="item-title">开始时间：</div>
        <div class="item-text">{{ details.startDate }}</div>
      </div>
      <div class="item-entry">
        <div class="item-title">结束时间：</div>
        <div class="item-text">{{ details.endDate }}</div>
      </div>
      <div class="item-entry">
        <div class="item-title">流程备注：</div>
        <div class="item-text">{{ details.remark }}</div>
      </div>
      <div class="item-entry">
        <div class="item-title">数量：</div>
        <div class="item-text">{{ details.number }}</div>
      </div>
      <div class="item-entry">
        <div class="item-title">现场负责人：</div>
        <div class="item-text">{{ details.director }}</div>
      </div>
      <div class="item-entry">
        <div class="item-title">联系方式：</div>
        <div class="item-text">{{ details.telephone }}</div>
      </div>
      <div class="item-entry" v-if="!isPass(details.verifyResult)">
        <div class="item-title">失败原因：</div>
        <div class="item-text">{{ getErrorStr(details.verifyResult) }}</div>
      </div>
      <div class="item-entry" style="margin-top: 30px;">
        <div class="item-title">上传附件：</div>
        <vg-image-uploader disabled :file-list="imageFiles"/>
      </div>
      <div class="item-link" v-for="(item,index) in otherFiles" :key="index">
        <van-image class="link-type" :src="srcPdf"/>
        <div class="link-url" @click="toLink(item.url)">{{ item.url }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {Image as VanImage} from "vant";
import VgImageUploader from "@/components/Commons/VgImageUploader";
import srcPdf from "@/assets/scanverify/pdf.svg";
import {client} from "@/libraries/http";

export default {
  name: "VerifyGoodsInOutDetail",
  components: {
    VanImage,
    VgImageUploader,
  },
  data() {
    return {
      srcPdf: srcPdf,
      id: undefined,
      details: {},
    }
  },
  computed: {
    imageFiles() {
      return this.details?.attachments.filter(att => att.type === 'IMG');
    },
    otherFiles() {
      return this.details?.attachments.filter(att => att.type !== 'IMG');
    },
  },
  created() {
    console.log(this.$route);
    this.id = this.$route.query.id;
    this.getDetail();
  },
  methods: {
    getDetail() {
      client.get("/api/h5/guard/verify/goods/detail/" + this.id).then(res => {
        console.log(res);
        this.details = res.data;
      })
    },
    getActionType(type) {
      if (type === 'OUT') {
        return '出货';
      } else if (type === 'IN') {
        return '进货';
      }
    },
    getErrorStr(result) {
      if (result === 'DIFF_PROJECT') {
        return '无效二维码，货品进出二维码所属项目与当前扫码验真项目不一致';
      } else if (result === 'COUNT_LIMIT') {
        return '货品进出二维码已达使用次数上限';
      } else if (result === 'EXPIRED') {
        return '货品进出二维码已过期';
      } else if (result === 'NOT_STARTED') {
        return '货品进出二维码未到开始时间';
      }
    },
    isPass(result) {
      return result === "PASS";
    },
    toLink(url) {
      window.open(url, '_blank');
    },
  },
}
</script>

<style scoped>
.vg-content {
  margin: 20px 15px;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #EDEBED;
  background: #FFFFFF;
}

.item {
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #EDEBED;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.item-entry {
  margin-top: 13px;
  display: flex;
  align-items: flex-start;
}

.item-title {
  min-width: 95px;
  font-size: 16px;
  color: #B4B4B4;
}

.item-text {
  font-size: 16px;
  color: #000000;
}

.item-link {
  margin-left: 95px;
  margin-top: 10px;
  display: flex;
  align-items: flex-start;
}

.link-type {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
}

.link-url {
  margin-left: 5px;
  font-size: 12px;
  color: #2897FF;
  word-break: break-all;
}

</style>